import React from 'react';

export default () => (
  <svg width="13" height="15" viewBox="0 0 13 15" fill="none">
    <path d="M11.75 5.25H8.75V0.75H4.25V5.25H1.25L6.5 11.25L11.75 5.25ZM0.5 12.75H12.5V14.25H0.5V12.75Z" fill="currentColor" />
  </svg>
)